import {FIELD_NAMES} from "profile/enums";

export const regex = {
    [FIELD_NAMES.WORK_EXPERIENCE_MONTHS]: "^([01]?[0-9]?[0-9]|2[0-9][0-9]|300)$",
    [FIELD_NAMES.HOUSE]: "^([a-zA-z0-9 . # @ & ( ) / , . : ' < > \- , \s]{1,60})$",
    [FIELD_NAMES.STREET]: "^([a-zA-z0-9 . # @ & ( ) / , . : ' < > \- , \s]{3,60})$",
    [FIELD_NAMES.LOCALITY]: "^([a-zA-z0-9 . # @ & ( ) / , . : ' < > \- , \s]{3,60})$",
    [FIELD_NAMES.LANDMARK]: "^([a-zA-z0-9 . # @ & ( ) / , . : ' < > \- , \s]{3,60})$",
    [FIELD_NAMES.PINCODE]: "^([0-9]{6})$",
    [FIELD_NAMES.REFERENCE_NAME]: "^[A-Za-z\s. ]{1,}$",
    [FIELD_NAMES.REFERENCE_MOBILE]: "^([5-9]{1}[0-9]{9})$",
    [FIELD_NAMES.BENEFICIARY_NAME]: "^[A-Za-z\s. ]{1,}$",
    [FIELD_NAMES.ACCOUNT_NUMBER]: "^[0-9a-zA-Z]{8,}$",
    [FIELD_NAMES.IFSC]: "^[A-Z]{4}0[A-Z0-9]{6}$",
    [FIELD_NAMES.AMOUNT]: "^([0-9]{1,})$",
    [FIELD_NAMES.TENURE]: "^(?!\s*$).+",
    [FIELD_NAMES.AADHAAR]: "^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$",
    [FIELD_NAMES.TOTAL_DEPENDENTS]: "^([0-9]{1})",
    [FIELD_NAMES.EMPLOYEE_ID]: "^(?!\s*$).+",
};
